// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__sGHqN","row":"Node_row__2m0eQ","label":"Node_label__1CFH-","footer":"Node_footer__G2DSG"};